import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
class BySalesLabelCategoryCityMobile extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"By Sales Label Category City"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    {
                    this.props.contactLeads.map((leadGroup, index) => {
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">{leadGroup.salesName}</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.leads.length} leads
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        leadGroup.leads.map((lead, indexLeads) => {
                                            return (
                                                <Paper elevation={2} sx={{mb: "10px", padding: "10px"}} key={`itemleads-${index}`}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Label</Typography>
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.label}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Kategori</Typography>
                                                            {/* {lead.label} */}
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.product_category}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Kota</Typography>
                                                            {/* {lead.label} */}
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.city}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Leads</Typography>
                                                            {/* {lead.label} */}
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.count_category}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Paper>
                                            );
                                        })
                                    }
                                    
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default BySalesLabelCategoryCityMobile;